// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"f3af41f3","455":"eadd0803"}[chunkId] + ".chunk.js";
};